import { render } from "./UserCardItem.vue?vue&type=template&id=022294ed&scoped=true"
import script from "./UserCardItem.vue?vue&type=script&lang=js"
export * from "./UserCardItem.vue?vue&type=script&lang=js"

import "./UserCardItem.vue?vue&type=style&index=0&id=022294ed&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022294ed"]])

export default __exports__